<template>
    <div
        class="flex flex-wrap"
        tabindex="0"
        @keyup.escape="$root.focusStep()"
    >
        <div
            v-for="(label, currentValue) in options"
            :key="currentValue"
            class="mr-2"
        >
            <input
                :id="inputName + currentValue"
                :checked="currentValue === value"
                :name="inputName"
                :value="currentValue"
                type="radio"
                @change="$emit('input', currentValue)"
            >
            <base-label :for="inputName + currentValue">{{ label }}</base-label>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseInputRadio',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: [String, Number],
    name: [String, Number]
  },

  data () {
    return {
      inputName: this.name || Math.random()
    }
  },

  emits: ['input']
}
</script>

<style scoped>

</style>
